<template>
    <v-container fluid color="grey lighten-3">
        <div class="background-wrapper"></div>
        <v-layout wrap justify-center align-center mt-4 fill-height>
            <v-flex xs12 md8 lg5  xl4 fill-height>
                <v-layout wrap justify-center align-center >
                    <v-flex xs12 class="text-xs-center">
                        <h1 class="caption mb-3 mt-2">AREA RESTRINGIDA, ES NECESARIO INICIAR SESION.</h1>
                    </v-flex>
                    <v-divider></v-divider>
                    <v-flex xs12 >
                        <standalone-login-form v-on:success="onLoginSuccess"/>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import StandaloneLoginForm from '@/components/common/StandaloneLoginForm'

    export default{
        components: {StandaloneLoginForm},
        methods:{
            onLoginSuccess(){
                const failedUrl = localStorage.failedUrl

                if(failedUrl){
                    localStorage.failedUrl = ''
                    this.$router.replace(failedUrl)
                }else{
                    this.$router.replace({
                        name: 'home'
                    })
                }
            }
        }
    }
</script>

<style scoped>
    .background-wrapper{
        position: fixed;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background-image: url('/images/401.jpg');
        background-size: cover;
        filter: blur(250px);
        background-position: center center;
        z-index: -1;
    }
</style>